export default __webpack_public_path__ + "static/media/zip.c66fcec1.svg";